/** Manual teleconsult visit cancellation reasons (staff Management + API parity). */
export const VISIT_CANCEL_REASON_OPTIONS = [
  { code: 'IN_PERSON_CONSULT', label: 'Chose in-person consult (Physical Clinic)' },
  { code: 'DUPLICATE_OR_WRONG_BOOKING', label: 'Duplicate or wrong booking' },
  { code: 'TECHNICAL_ISSUE', label: 'Technical issue - app/device/network' },
  { code: 'LONG_WAITING_TIME', label: 'Long waiting time' },
  { code: 'PATIENT_UNCONTACTABLE', label: 'Patient uncontactable' },
  { code: 'OTHER', label: 'Other - specify' },
] as const;

export type VisitCancelReasonCode = (typeof VISIT_CANCEL_REASON_OPTIONS)[number]['code'];

export const VISIT_CANCEL_REASON_OTHER: VisitCancelReasonCode = 'OTHER';

export const VISIT_CANCEL_REASON_MIN_OTHER = 3;
export const VISIT_CANCEL_REASON_MAX_OTHER = 500;

export function visitCancelReasonLabel(code: string | null | undefined): string | null {
  if (!code) return null;
  const hit = VISIT_CANCEL_REASON_OPTIONS.find((o) => o.code === code);
  return hit?.label ?? null;
}

export function isVisitCancelReasonValid(
  code: string | null | undefined,
  other: string | null | undefined,
): boolean {
  if (!code) return false;
  const hit = VISIT_CANCEL_REASON_OPTIONS.some((o) => o.code === code);
  if (!hit) return false;
  if (code === VISIT_CANCEL_REASON_OTHER) {
    const t = (other ?? '').trim();
    return t.length >= VISIT_CANCEL_REASON_MIN_OTHER && t.length <= VISIT_CANCEL_REASON_MAX_OTHER;
  }
  return true;
}
